import React from 'react'
import {
    MDBInput,
  } from 'mdb-react-ui-kit';

const Cform = () => {
  return (
    <form>
      <MDBInput id='form4Example1' wrapperClass='mb-4' label='Name' />
      <MDBInput type='email' id='form4Example2' wrapperClass='mb-4' label='Email address' />
      <MDBInput wrapperClass='mb-4' textarea id='form4Example3' rows={4} label='Message' />

      <div type='submit' className='mb-4 c-btn' block>
        Send Message
      </div>
    </form>
  )
}

export default Cform

